/**
 * 模組頁面代碼 : 1430-UI-02
 * 頁面說明 : 部門列表畫面
 * @module web/modules/department/components/DepartmentModal
 */

// ----- import from npm modules ----
import $ from 'jquery';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

// ----- import from local modules -----
import enumList from 'web/utils/enumList';
import {AlertModalModeEnums} from 'web/components/AlertModal';
import {BaseComponent} from 'web/components/BaseComponent';
import {
  addDepartment,
  editDepartment,
} from 'web/redux/actions/DepartmentActions';

// ----- constants -----
import {TITLE_DEPARTMENT_NEW, TITLE_DEPARTMENT_EDIT} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {useSelector} from 'react-redux';

const DepartmentModel = React.forwardRef((props, ref) => {
  const {
    onDepartment,
    toggleDepartmentEditModal,
    reloadDepartmentList,
    mode,
    setNeedEmployeeLoad,
  } = props;
  const dispatch = useDispatch();
  const currentSelect = useSelector(
    (state) => state.department.departmentSelection.data,
  );

  useEffect(() => {
    if (currentSelect) {
      setFormValues({
        modalDeparmentId: currentSelect.departmentId,
        modalDepartmentCode: currentSelect.departmentCode,
        modalDepartmentName: currentSelect.departmentName,
      });
    }
  }, [currentSelect]);

  const baseComponent = new BaseComponent(props);
  const [formValues, setFormValues] = useState({
    modalDeparmentId: 0,
    modalDepartmentCode: '',
    modalDepartmentName: '',
  });
  const [invalidShow, setInvalidShow] = useState('none');
  const modalIcon = mode === enumList.modalMode.new ? '#ico-plus' : '#ico-edit';
  const modalTitleText =
    mode === enumList.modalMode.new
      ? TITLE_DEPARTMENT_NEW
      : TITLE_DEPARTMENT_EDIT;

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // 檢查表單是否驗證通過
    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    const req = {
      departmentId: formValues.modalDeparmentId,
      departmentCode: formValues.modalDepartmentCode,
      departmentName: formValues.modalDepartmentName,
    };
    if (mode === enumList.modalMode.edit) {
      submitEditDepartment(req);
    }
    if (mode === enumList.modalMode.new) {
      submitAddDepartment(req);
    }
    form.classList.remove('was-validated');
    resetForm();
    setNeedEmployeeLoad(true);
  };

  const submitAddDepartment = (req) => {
    dispatch(addDepartment(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode.isSuccessCode()) {
        // const departmentList = res.payload.result;
        onDepartment();
        reloadDepartmentList();
        // prepareDepartmentTable(departmentList);
      } else {
        onDepartment();
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );

        console.error('fetchDepartmentList error', res);
      }
    });
  };
  const submitEditDepartment = (req) => {
    dispatch(editDepartment(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode.isSuccessCode()) {
        onDepartment();
        reloadDepartmentList();
      } else {
        // toggleDepartmentEditModal(false);
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );
      }
    });
  };

  // Handle change event
  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;

    setFormValues({
      ...formValues,
      [target.name]: value,
    });
  };

  const resetForm = () => {
    setFormValues({
      modalDepartmentCode: '',
      modalDepartmentName: '',
    });
  };

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modalDepartment"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalDepartmentLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalAccountForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalAccountLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setTimeout(resetForm, 500)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-3">
                  <div className="modal__form__catagory__lable">部門資訊</div>
                </div>
                <div className="col-9">
                  <div className="row">
                    <div className="col-6">
                      <label
                        htmlFor="modalDepartmentCode"
                        className="form-label"
                      >
                        部門代號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalDepartmentCode"
                        name="modalDepartmentCode"
                        value={formValues.modalDepartmentCode}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-6">
                      <label htmlFor="modalUserPosition" className="form-label">
                        部門名稱*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalDepartmentName"
                        name="modalDepartmentName"
                        value={formValues.modalDepartmentName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-cancel"
              data-bs-dismiss="modal"
              onClick={() => setTimeout(resetForm, 500)}
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default DepartmentModel;
